module.exports = __webpack_public_path__ + "static/media/BGsearchStudentAdmin.620308dc.svg";